// Implements: .claude/skills/rehaut-design/ui_kits/rehaut-pacientes/primitives.jsx (KeyHint)
// See: .claude/skills/rehaut-design/HANDOFF.md
'use client';

/**
 * Keyboard-shortcut affordance — one or more `<kbd>` chips. Used in
 * the footer hints, the cmdk palette, and inline next to action
 * buttons that have a key binding ("Editar [E]"). Style is governed
 * by the `kbd { ... }` rule in globals.css.
 */
export function KeyHint({ keys }: { keys: string[] }) {
  return (
    <span
      className="kbd-hint"
      style={{ display: 'inline-flex', gap: '3px', alignItems: 'center', flexShrink: 0 }}
      aria-label={`Atajo: ${keys.join(' ')}`}
    >
      {keys.map((k, i) => (
        <kbd key={i}>{k}</kbd>
      ))}
    </span>
  );
}
